import { useEffect } from 'react'
import { createGlobalStyle } from 'styled-components'
import { QueryClient } from 'react-query'
import { dehydrate } from 'react-query/hydration'
import { useCountryCode } from 'querys/payment'
import Navigation from 'components/navigation'
import {
  prefetchSubscriptionPlans,
  useSubscriptionPlans,
} from 'querys/subscriptions'
import { prefetchSmallCoursesList } from 'querys/course'
import InternalError from 'errors/internal-error'
import Quote from 'components/prices/quote'
import Footer from 'common/footer'
import OpenGraph from 'common/open-graph'
import ReasonsToStudy from 'components/prices/reasons-to-study'
import PricingSection from 'components/prices/pricing-section'
import Divider from 'common/divider'

const GlobalStyle = createGlobalStyle`
  .exclusive {
    display: block;
    background: var(--secondary);
    margin-block-start: 16px;
    font: var(--smallBold);
    width: fit-content;
    padding: 4px 8px;
  }
`

function Prices() {
  const { error } = useSubscriptionPlans()
  const { refetch } = useCountryCode()

  useEffect(() => {
    refetch()
  }, [])

  if (error?.message === 'User Unauthorized') return null
  if (error?.message === 'Internal Error') return <InternalError />

  return (
    <>
      <OpenGraph
        title="¡La práctica hace al maestro!"
        description="Esto es aprendizaje basado en proyectos"
        url="https://leonidasesteban.com/precios"
      />
      <GlobalStyle />
      <Navigation noCountdown />
      <PricingSection />
      <Divider color="transparent" marginVertical={50} />
      <ReasonsToStudy />
      <Quote />
      <Footer />
    </>
  )
}

Prices.pageTheme = {
  background: 'var(--sky)',
}

export async function getStaticPaths() {
  const countries = ['mx', 'international']
  const paths = []

  countries.forEach((country) => {
    paths.push({ params: { variant: `${country}` } })
  })

  return {
    paths,
    fallback: false,
  }
}

export async function getStaticProps(context) {
  const {
    params: { variant },
  } = context

  const queryClient = new QueryClient()
  const countryCode = variant === 'international' ? 'US' : 'MX'

  queryClient.setQueryData(['GET_COUNTRY_CODE', null], () => ({
    countryCode,
  }))
  await prefetchSubscriptionPlans({ queryClient, countryCode })
  await prefetchSubscriptionPlans({
    queryClient,
    coupon_code: 'ppp',
    countryCode,
  })
  await prefetchSmallCoursesList({ queryClient, countryCode })

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
    revalidate: 600,
  }
}

export default Prices
